import React from "react";
import { createRoot } from "react-dom/client";
import { Controller } from "@hotwired/stimulus";
import { QueryClientProvider } from "react-query";
import queryClient from "../../../helpers/queryClient";
import InviteDetailsModal from "../../../components/administration/invites/InviteDetailsModal";
import RenewInviteModal from "../../../components/administration/invites/RenewInviteModal";
import InvitesExport from "../../../components/administration/invites/InvitesExport";
import { visit } from "@hotwired/turbo";

// Connects to data-controller="administration--invites--sent"
export default class extends Controller {
  static targets = ["exporter"];

  connect() {
    this.childElement = document.createElement("div");
    this.element.appendChild(this.childElement);
    this.root = createRoot(this.childElement);
  }

  // Also fires after Turbo replaced the frame contents (filter/search/pagination),
  // so the exporter survives frame navigation and picks up the new filter values
  exporterTargetConnected(target) {
    this.exporterRoot = createRoot(target);
    this.exporterRoot.render(
      <QueryClientProvider client={queryClient}>
        <InvitesExport
          status={target.dataset.status}
          search={target.dataset.search}
          showDeleted={target.dataset.showDeleted === "true"}
        />
      </QueryClientProvider>,
    );
  }

  exporterTargetDisconnected() {
    this.exporterRoot?.unmount();
    this.exporterRoot = undefined;
  }

  onCloseModal() {
    this.root.render(React.createElement(React.Fragment, null));
  }

  refreshTable() {
    const pageField = document.querySelector("input[name='page']");
    const page = pageField ? pageField.value : "1";
    const url = new URL(location.pathname, window.location.origin);
    url.searchParams.set("page", page);

    visit(url.toString(), {
      frame: "external-invites-view",
      action: "replace",
    });
  }

  showInviteDetails(event) {
    const inviteId = event.params.inviteId;
    this.root.render(
      <QueryClientProvider client={queryClient}>
        <InviteDetailsModal
          inviteId={inviteId}
          setShowModal={(show) => {
            if (!show) this.onCloseModal();
          }}
        />
      </QueryClientProvider>,
    );
  }

  refreshInvite(event) {
    const inviteId = event.params.inviteId;
    this.root.render(
      <QueryClientProvider client={queryClient}>
        <RenewInviteModal
          inviteId={inviteId}
          setShowModal={(show) => {
            if (!show) this.onCloseModal();
          }}
          onSuccess={() => this.refreshTable()}
        />
      </QueryClientProvider>,
    );
  }

  disconnect() {
    this.root.unmount();
    this.childElement?.remove();
  }
}
